import { TabsDesignTokens } from '@primeuix/themes/types/tabs';

export const Tabs: TabsDesignTokens = {
  tablist: {
    background: 'transparent',
  },
  tab: {
    borderColor: 'transparent',
    borderWidth: '1px',
    activeColor: '{surface.900}',
    color: '{surface.700}',
    activeBorderColor: 'transparent',
    hoverBackground: '{primary.50}',
    hoverBorderColor: 'transparent',
  },
  activeBar: {
    height: '3px',
    background: '{green.500}',
  },
  css: () => `
    .p-tab {
      border-radius: 0.5rem 0.5rem 0 0;
      font-weight: 600;
    }
    .p-tab-active {
    font-weight: 700;
    }
    `,
};
